module.exports = __webpack_public_path__ + "static/img/tipping-img.fd197f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tipping-img.png
// module id = /wS2
// module chunks = 1